module.exports = __webpack_public_path__ + "img/icon_menu_pinterest_black.511571cf.svg";